const PREFIX = 'entity'

const getEntityLangKeys = (name) => ({
  title: `${PREFIX}-${name}-title`,
  subtitle: `${PREFIX}-${name}-subtitle`,
})

export default getEntityLangKeys
